export function getdata(){
  let obj = {
    searchlist:[
      {
        prop: "businessName",
        label: '操作日志',
        type: "input"
      },
      {
        prop: "createDate",
        label: '操作时间',
        type: "date",
        valueformat:'yyyy-MM-dd'
      },{
        prop: "operName",
        label: '操作人员',
        type: "input"
      },
    ],
    searchdata:{
      businessName:'',
      createDate:'',
      operName:'',
    },
    headData:[
      {
        title: '操作日志',
        prop: 'businessName',
        width: '150',
        custom:true,
      },{
        title: '操作时间',
        prop: 'createDate',
        width: '150',
        custom:true,
      },{
        title: '操作人员',
        prop: 'operName',
        width: '150',
        custom:true,
      }
    ],
    pagination:{
      pageNum: 1,
      pageSize: 50,
      total: 3,
      paginationkey: 0
    }
  }
  return obj
}